// extracted by mini-css-extract-plugin
export default {"profileInfo":"UserProfile_profileInfo__x+F+f","item":"UserProfile_item__SZpPh","lastBook":"UserProfile_lastBook__CVyGD"};